import React, { lazy, Suspense, useEffect } from "react";
import "./scrollbar.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Pages/Home";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import { useState } from "react";
import DottedBackground from "./components/DottedBackground";

const Resume = lazy(() => import("./components/Pages/Resume"));
const MyProjects = lazy(() => import("./components/Pages/MyProjects"));
const Contact = lazy(() => import("./components/Pages/Contactme"));
const Chatbot = lazy(() => import("./components/Chatbot/Chatbot"));

const PageLoader = () => (
  <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white dark:bg-slate-900 transition-colors duration-300">
    {/* Dual-ring spinner */}
    <div className="relative w-12 h-12 mb-6">
      <div className="absolute inset-0 rounded-full border-[2.5px] border-transparent border-t-gray-800 dark:border-t-gray-200 animate-spin" style={{ animationDuration: '1s', animationTimingFunction: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)' }}></div>
      <div className="absolute inset-[6px] rounded-full border-[2.5px] border-transparent border-b-gray-400 dark:border-b-slate-500 animate-spin" style={{ animationDuration: '0.8s', animationTimingFunction: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)', animationDirection: 'reverse' }}></div>
    </div>
    {/* Pulsing dots */}
    <div className="flex gap-1.5">
      <span className="w-1.5 h-1.5 rounded-full bg-gray-400 dark:bg-slate-500 animate-pulse" style={{ animationDelay: '0s' }}></span>
      <span className="w-1.5 h-1.5 rounded-full bg-gray-400 dark:bg-slate-500 animate-pulse" style={{ animationDelay: '0.2s' }}></span>
      <span className="w-1.5 h-1.5 rounded-full bg-gray-400 dark:bg-slate-500 animate-pulse" style={{ animationDelay: '0.4s' }}></span>
    </div>
  </div>
);



function App() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  // Dismiss the initial HTML loader once React mounts
  useEffect(() => {
    const initialLoader = document.getElementById('initial-loader');
    if (initialLoader) {
      initialLoader.classList.add('hidden');
      setTimeout(() => initialLoader.remove(), 500);
    }
  }, []);

  return (
    <div className="App bg-white dark:bg-slate-900 dark:text-gray-100 min-h-screen min-h-[100dvh] flex flex-col overflow-x-hidden relative transition-colors duration-300">
      <DottedBackground />
      
      {/* Painting/Spilled Colors Effects — blend mode changes for dark */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] w-[50vw] h-[50vw] min-w-[300px] min-h-[300px] rounded-full bg-teal-100/40 dark:bg-teal-900/20 blur-[120px] mix-blend-multiply dark:mix-blend-screen animate-pulse"></div>
        <div className="absolute top-[10%] -right-[10%] w-[40vw] h-[60vw] min-w-[300px] min-h-[300px] rounded-full bg-blue-100/30 dark:bg-blue-900/15 blur-[100px] mix-blend-multiply dark:mix-blend-screen"></div>
        <div className="absolute top-[60%] -left-[20%] w-[60vw] h-[60vw] min-w-[300px] min-h-[300px] rounded-full bg-red-100/30 dark:bg-red-900/10 blur-[150px] mix-blend-multiply dark:mix-blend-screen"></div>
        <div className="absolute -bottom-[10%] -right-[10%] w-[50vw] h-[50vw] min-w-[300px] min-h-[300px] rounded-full bg-sky-100/30 dark:bg-sky-900/15 blur-[130px] mix-blend-multiply dark:mix-blend-screen animate-pulse"></div>
      </div>

      <Router>
        {!isChatbotOpen && <Navbar className="hidden md:block" />}
        {!isChatbotOpen && <Sidebar className="block md:hidden" />}
        {!isChatbotOpen && (
          <div className="flex-grow">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/projects" element={<MyProjects />} />
                <Route path="/contactme" element={<Contact />} />
              </Routes>
            </Suspense>
          </div>
        )}
        <Suspense fallback={null}>
          <Chatbot isOpen={isChatbotOpen} setIsOpen={setIsChatbotOpen} />
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
